import { LOGIN_FAIL, REGISTER_FAIL } from '@comeon/actions-public';

export const SHOW_NOTIFICATION = '@komigen/mobile-frontend/notifications/SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = '@komigen/mobile-frontend/notifications/HIDE_NOTIFICATION';
export const SHOW_BINARY_NOTIFICATION = '@komigen/mobile-frontend/notifications/SHOW_BINARY_NOTIFICATION';
export const HIDE_BINARY_NOTIFICATION = '@komigen/mobile-frontend/notifications/HIDE_BINARY_NOTIFICATION';
export const BINARY_QUESTION_OPEN = '@komigen/mobile-frontend/notifications/BINARY_QUESTION_OPEN';

/**
 * @typedef {Object} ShowNotificationOpts
 * @property {String=} message
 * @property {String=} messageKey
 * @property {boolean=} autoHide
 * @property {String} color
 * @property {Number=} autoHideDuration
 * @property {String=} buttonLink
 * @property {String=} buttonLinkInternal
 * @property {String=} buttonText
 * @property {String=} buttonTextKey
 * @property {null|Function=} buttonCB
 * @property {Function=} onClose
 * @property {Function=} onCloseClickCallback
 * @property {boolean=} openInSidebar
 * @property {Number=} autoHideDuration
 * @property {boolean=} buttonBottom
 * @property {boolean=} buttonInline
 */

/**
 * @deprecated This function will be removed in future versions. Use showQueuedNotification instead.
 */
const showNotification =
	(
		/** @type ShowNotificationOpts */ {
			icon,
			message,
			messageKey,
			title,
			titleKey,
			color,
			autoHide,
			autoHideDuration,
			buttonLink,
			linkCB,
			buttonLinkInternal,
			buttonText,
			buttonTextKey,
			buttonInline,
			buttonCB,
			centerAligned,
			onClose = () => {},
			openInSidebar = false,
			onCloseClickCallback,
			onBluebarClick,
			customMargin,
			buttonBottom
		}
	) =>
	dispatch => {
		dispatch({
			type: SHOW_NOTIFICATION,
			icon,
			message,
			messageKey,
			title,
			titleKey,
			color,
			buttonLink,
			linkCB,
			buttonLinkInternal,
			buttonText,
			buttonTextKey,
			buttonInline,
			buttonCB,
			centerAligned,
			openInSidebar,
			onCloseClickCallback,
			onBluebarClick,
			customMargin,
			buttonBottom
		});

		if (autoHide) {
			setTimeout(() => {
				dispatch({
					type: HIDE_NOTIFICATION
				});
				onClose();
			}, autoHideDuration || 5000);
		}
	};

const hideNotification = () => ({
	type: HIDE_NOTIFICATION
});

const hideBinaryNotification = () => ({
	type: HIDE_BINARY_NOTIFICATION
});

/**
 *
 * @param {Object} args
 * @param {string} args.message
 * @param {string} args.messageKey
 * @param {string} args.header
 * @param {string} args.headerKey
 * @param {string} args.yesText
 * @param {string} args.yesTextKey
 * @param args.onYesClick
 * @param {string} args.noText
 * @param {string} args.noTextKey
 * @param args.onNoClick
 * @param {bool} args.hasInput
 * @param {string} args.inputValue
 * @param {function} args.onChange
 * @returns {function(*)}
 */
const showBinaryQuestion =
	({
		message,
		messageKey,
		header,
		headerKey,
		yesText,
		yesTextKey,
		onYesClick,
		noText,
		noTextKey,
		onNoClick,
		hasInput = false,
		inputValue,
		inputType,
		onChange,
		onOutsideClick,
		maxlength,
		reverseOrder
	}) =>
	dispatch => {
		dispatch({
			type: SHOW_BINARY_NOTIFICATION,
			message,
			messageKey,
			header,
			headerKey,
			yesText,
			yesTextKey,
			onYesClick,
			noText,
			noTextKey,
			onNoClick,
			hasInput,
			inputValue,
			inputType,
			onChange,
			onOutsideClick,
			maxlength,
			reverseOrder
		});
	};

const binaryQuestionIsOpen = () => {
	return { type: BINARY_QUESTION_OPEN };
};
const selectBinaryQuestionData = state => state.notifications.binaryQuestionData;

function reducer(
	state = {
		shouldOpen: false,
		icon: null,
		message: '',
		messageKey: undefined,
		title: '',
		titleKey: undefined,
		color: 'green',
		buttonLink: '',
		linkCB: null,
		buttonText: '',
		buttonTextKey: undefined,
		buttonInline: false,
		buttonCB: null,
		centerAligned: false,
		binaryQuestionData: {
			shouldOpenBinary: false,
			message: '',
			messageKey: '',
			header: '',
			headerKey: '',
			yesText: '',
			yesTextKey: '',
			onYesClick: '',
			noText: '',
			noTextKey: '',
			onNoClick: '',
			hasInput: false,
			inputValue: '',
			inputType: '',
			onChange: '',
			onOutsideClick: ''
		},
		customMargin: '',
		openInSidebar: false,
		popupMessageData: {},
		onCloseClickCallback: undefined,
		onBluebarClick: null,
		buttonBottom: false
	},
	action
) {
	switch (action.type) {
		case SHOW_NOTIFICATION:
			return {
				shouldOpen: true,
				message: action.message,
				messageKey: action.messageKey,
				icon: action.icon,
				title: action.title,
				titleKey: action.titleKey,
				color: action.color,
				buttonLink: action.buttonLink,
				linkCB: action.linkCB,
				buttonLinkInternal: action.buttonLinkInternal,
				buttonText: action.buttonText,
				buttonTextKey: action.buttonTextKey,
				buttonInline: action.buttonInline,
				buttonCB: action.buttonCB,
				centerAligned: action.centerAligned,
				binaryQuestionData: state.binaryQuestionData,
				openInSidebar: action.openInSidebar,
				popupMessageData: {},
				onCloseClickCallback: action.onCloseClickCallback,
				onBluebarClick: action.onBluebarClick,
				customMargin: action.customMargin,
				buttonBottom: action.buttonBottom
			};
		case SHOW_BINARY_NOTIFICATION:
			return {
				shouldOpen: state.shouldOpen,
				message: state.message,
				color: state.color,
				binaryQuestionData: {
					shouldOpenBinary: true,
					message: action.message,
					messageKey: action.messageKey,
					header: action.header,
					headerKey: action.headerKey,
					yesText: action.yesText,
					yesTextKey: action.yesTextKey,
					onYesClick: action.onYesClick,
					noText: action.noText,
					noTextKey: action.noTextKey,
					onNoClick: action.onNoClick,
					hasInput: action.hasInput,
					inputValue: action.inputValue,
					inputType: action.inputType,
					onChange: action.onChange,
					onOutsideClick: action.onOutsideClick,
					maxlength: action.maxlength,
					reverseOrder: action.reverseOrder
				},
				openInSidebar: state.openInSidebar,
				popupMessageData: state.popupMessageData
			};
		case HIDE_NOTIFICATION:
			return {
				shouldOpen: false,
				binaryQuestionData: state.binaryQuestionData,
				popupMessageData: state.popupMessageData
			};
		case HIDE_BINARY_NOTIFICATION:
			return {
				...state,
				binaryQuestionData: {
					shouldOpenBinary: false
				},
				popupMessageData: {},
				blockScroll: false
			};
		case BINARY_QUESTION_OPEN:
			return {
				...state,
				blockScroll: true
			};
		case LOGIN_FAIL:
			return {
				...state,
				popupMessageData: action.payload
			};
		case REGISTER_FAIL:
			return {
				...state,
				popupMessageData: action.payload
			};
		default:
			return state;
	}
}

export {
	showNotification,
	hideNotification,
	showBinaryQuestion,
	hideBinaryNotification,
	selectBinaryQuestionData,
	binaryQuestionIsOpen
};

export default reducer;
